module.exports = __webpack_public_path__ + "d1bfe108a196944abc502523ce840bc3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/strategyshares.png
// module id = 1741
// module chunks = 0